import $ from 'jquery';

$.addInit(function(context){
	var base = '.b-navTags';
	$(base, context).each(function(i, el){
		var $el = $(el);
		var list = $el.find(base + '-list');
		var container = $el.find(base + '-container');
		var active = list.find('input:checked').closest('.b-navTags-item')[0];

		function scrollToActiveItem() {
			if (!active) return;
			var scrollParent = container[0];
			var scrollParentWidth = scrollParent.clientWidth;
			var activeElWidth = active.clientWidth;
			var activeElLeftOffset = active.offsetLeft;
			var isActiveElInvisible = activeElLeftOffset + activeElWidth > scrollParentWidth;

			if (isActiveElInvisible) {
				scrollParent.scrollLeft = activeElLeftOffset - (scrollParentWidth / 2) + (activeElWidth / 2);
			} else {
				scrollParent.scrollLeft = 0;
			}
		}

		scrollToActiveItem();

		$(window).on('resize', scrollToActiveItem);
	});
});
